import { render } from "./LessonsDeleteDialog.vue?vue&type=template&id=0d141f43&scoped=true"
import script from "./LessonsDeleteDialog.vue?vue&type=script&lang=js"
export * from "./LessonsDeleteDialog.vue?vue&type=script&lang=js"

import "./LessonsDeleteDialog.vue?vue&type=style&index=0&id=0d141f43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d141f43"]])

export default __exports__